import { useState } from 'react';

interface ReturnedBannerProps {
  approverName: string;
  comment: string;
}

export function ReturnedBanner({ approverName, comment }: ReturnedBannerProps) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="returned-banner" role="alert">
      <svg
        className="returned-banner__icon"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M8 1L1 14h14L8 1zm0 2.8L13.1 13H2.9L8 3.8zm-.75 3.7v2.5h1.5V7.5h-1.5zm0 3.5v1.5h1.5V11h-1.5z" />
      </svg>
      <div className="returned-banner__body">
        <span className="returned-banner__label">Returned for correction</span>
        <span className="returned-banner__text">
          <strong>{approverName}:</strong> &ldquo;{comment}&rdquo;
        </span>
      </div>
      <button
        type="button"
        className="returned-banner__dismiss"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">
          <path
            d="M1 1l10 10M11 1L1 11"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
      </button>
    </div>
  );
}
